import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "url"]

  upload(event) {
    const file = event.target.files[0]
    if (!file) return

    // For now, just show a preview (actual upload would require a service)
    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.innerHTML = `
        <img src="${e.target.result}" class="w-32 h-32 rounded-full object-cover border-4 border-beige-200">
      `
      // Note: For production, you'd upload to S3/Cloudinary/Filestack and set the URL
      // this.urlTarget.value = uploadedUrl
    }
    reader.readAsDataURL(file)
  }
}
